import React from 'react';
import { empoweringData } from '../data/mock';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';

const EmpoweringSection = () => {
  const { isDark } = useTheme();
  const { startCheckout } = useCheckout();
  const t = useT();
  const tc = isDark ? '#FFFFFF' : '#1B2A4A';

  return (
    <section className="mt-24 relative px-[30px] lg:px-0" id="reviews">
      <div className="absolute top-0 left-0 h-full w-full pointer-events-none bg-no-repeat bg-cover bg-center" style={{ backgroundImage: 'url(https://www.university.com/empowering_bg.png)', opacity: isDark ? 0.15 : 1 }} />

      <h3 className="text-center text-[13px] tracking-[0.35em] font-medium uppercase relative z-10 transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : tc }}>{t.empowering.label}</h3>
      <h2 className="text-center max-w-3xl mx-auto text-[32px] lg:text-[48px] font-bold leading-[1.15] mt-1 relative z-10 transition-colors duration-300" style={{ fontFamily: '"Space Grotesk", sans-serif', color: tc }}>
        {t.empowering.title}
      </h2>

      <div className="mx-auto max-w-[1408px] relative z-10">
        <div className="flex items-center justify-center gap-12 mt-8 px-8">
          <button className={`text-4xl cursor-pointer z-40 relative p-4 border-[2px] rounded-full duration-300 transition-all hidden lg:block ${isDark ? 'tech-glow' : ''}`} style={{ color: isDark ? '#E6EBF2' : 'white', borderColor: isDark ? '#E6EBF2' : 'white' }}><ArrowLeft size={24} /></button>
          <div className="w-full max-w-[794px] relative">
            <div className={`relative ${isDark ? 'tech-border' : ''}`} style={{ background: isDark ? 'rgba(0,0,0,0.5)' : 'linear-gradient(rgba(255,255,255,0.31) 0%, rgba(255,255,255,0.11) 100%)', padding: '1px' }}>
              <div className="min-h-[280px] lg:min-h-[430px] w-full relative cursor-pointer" style={{ paddingTop: '56.25%' }} onClick={() => startCheckout('empowering_video')} data-testid="empowering-play-btn">
                <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${empoweringData.videoThumbnail})` }} />
                <div className="absolute inset-0 bg-transparent hover:bg-[rgba(0,0,0,.15)] transition-all duration-300" />
              </div>
            </div>
          </div>
          <button className={`text-4xl cursor-pointer z-40 relative p-4 border-[2px] rounded-full duration-300 transition-all hidden lg:block ${isDark ? 'tech-glow' : ''}`} style={{ color: isDark ? '#E6EBF2' : 'white', borderColor: isDark ? '#E6EBF2' : 'white' }}><ArrowRight size={24} /></button>
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 mt-4 relative z-20">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="w-[25px] h-[4px]" style={{ backgroundColor: i === 1 ? (isDark ? '#E6EBF2' : tc) : (isDark ? 'rgba(0,212,255,0.15)' : '#E0E0E0') }} />
        ))}
      </div>

      <p className="copy-text max-w-2xl text-center mx-auto mt-8 relative z-20 text-[17px] leading-[1.7] transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.6)' : 'black' }} dangerouslySetInnerHTML={{ __html: t.empowering.description }} />

      <div className="mx-auto max-w-[1408px] relative z-20">
        <div className="flex justify-center w-full mt-8">
          <div onClick={() => startCheckout('empowering_cta')} className="cursor-pointer" data-testid="empowering-cta-btn">
            <button className={`lg:w-min lg:min-w-[266px] text-xl border-2 p-[1px] group duration-300 transition-all font-bold ${isDark ? 'tech-glow' : ''}`} style={{ backgroundColor: isDark ? '#000000' : 'white', borderColor: isDark ? '#E6EBF2' : tc }}>
              <div className="py-3.5 px-9 group-hover:bg-transparent duration-300 transition-all m-[1px]" style={{ backgroundColor: isDark ? '#E6EBF2' : tc, color: isDark ? '#000000' : 'white' }}>
                {t.hero.cta}
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmpoweringSection;
